export default function validate(fields) {
    const errors = {}
    const { cameraSn, endpoint } = fields
    if (typeof cameraSn === 'undefined' || cameraSn === '') {
        errors.cameraSn = 'Camera SN must not be empty'
    }
    var cameraSnPatt = /^([0-9a-f]{2}[:]){5}([0-9a-f]{2})$/;
    if (!cameraSnPatt.test(cameraSn)) {
        errors.cameraSn = 'Camera SN format must be correct for example: 80:1f:12:7c:e1:82'
    }
    
    if (typeof endpoint === 'undefined' || endpoint === '') {
        errors.endpoint = 'Endpoint must not be empty'
    }
    var endpointPatt = /^((25[0-5]|(2[0-4]|1[0-9]|[1-9]|)[0-9])(\.(?!$)|$)){4}$/;
    if (!endpointPatt.test(endpoint)) {
        errors.endpoint = 'Endpoint format range must be from 0.0.0.0 to 255.255.255.255'
    }
    return errors
}



// WEBPACK FOOTER //
// ./src/smart-components/camera-form/validate.js